/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignRawMetricRequest,
  CoverageRepresentation,
  CoverageRequest,
  CreateMetricRequest,
  MetricRepresentation,
  RawMetricRepresentation,
  UpdateMetricRequest,
} from '../models/index';
import {
    AssignRawMetricRequestFromJSON,
    AssignRawMetricRequestToJSON,
    CoverageRepresentationFromJSON,
    CoverageRepresentationToJSON,
    CoverageRequestFromJSON,
    CoverageRequestToJSON,
    CreateMetricRequestFromJSON,
    CreateMetricRequestToJSON,
    MetricRepresentationFromJSON,
    MetricRepresentationToJSON,
    RawMetricRepresentationFromJSON,
    RawMetricRepresentationToJSON,
    UpdateMetricRequestFromJSON,
    UpdateMetricRequestToJSON,
} from '../models/index';

export interface AssignRawMetricOperationRequest {
    rawkey: string;
    dpkey: string;
    assignRawMetricRequest: AssignRawMetricRequest;
}

export interface CreateNewMetricRequest {
    createMetricRequest: CreateMetricRequest;
}

export interface GetAllRawMetricsRequest {
    assigned?: boolean;
    dataprovider?: string;
}

export interface GetCoverageForAllMetricsRequest {
    coverageRequest: CoverageRequest;
}

export interface UpdateMetricOperationRequest {
    key: string;
    updateMetricRequest: UpdateMetricRequest;
}

/**
 * 
 */
export class MetricsApi extends runtime.BaseAPI {

    /**
     * Assign a raw metric to a derived metric to activate its import.
     * Assign raw metric
     */
    async assignRawMetricRaw(requestParameters: AssignRawMetricOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RawMetricRepresentation>> {
        if (requestParameters['rawkey'] == null) {
            throw new runtime.RequiredError(
                'rawkey',
                'Required parameter "rawkey" was null or undefined when calling assignRawMetric().'
            );
        }

        if (requestParameters['dpkey'] == null) {
            throw new runtime.RequiredError(
                'dpkey',
                'Required parameter "dpkey" was null or undefined when calling assignRawMetric().'
            );
        }

        if (requestParameters['assignRawMetricRequest'] == null) {
            throw new runtime.RequiredError(
                'assignRawMetricRequest',
                'Required parameter "assignRawMetricRequest" was null or undefined when calling assignRawMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/raw-metrics/{rawkey}/dataprovider/{dpkey}/assign`;
        urlPath = urlPath.replace(`{${"rawkey"}}`, encodeURIComponent(String(requestParameters['rawkey'])));
        urlPath = urlPath.replace(`{${"dpkey"}}`, encodeURIComponent(String(requestParameters['dpkey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignRawMetricRequestToJSON(requestParameters['assignRawMetricRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RawMetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Assign a raw metric to a derived metric to activate its import.
     * Assign raw metric
     */
    async assignRawMetric(rawkey: string, dpkey: string, assignRawMetricRequest: AssignRawMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RawMetricRepresentation> {
        const response = await this.assignRawMetricRaw({ rawkey: rawkey, dpkey: dpkey, assignRawMetricRequest: assignRawMetricRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new metric for later assignment to raw data provider metrics.
     * Create metric
     */
    async createNewMetricRaw(requestParameters: CreateNewMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricRepresentation>> {
        if (requestParameters['createMetricRequest'] == null) {
            throw new runtime.RequiredError(
                'createMetricRequest',
                'Required parameter "createMetricRequest" was null or undefined when calling createNewMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMetricRequestToJSON(requestParameters['createMetricRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new metric for later assignment to raw data provider metrics.
     * Create metric
     */
    async createNewMetric(createMetricRequest: CreateMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricRepresentation> {
        const response = await this.createNewMetricRaw({ createMetricRequest: createMetricRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Return all metric objects for the current user
     */
    async getAllMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MetricRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MetricRepresentationFromJSON));
    }

    /**
     * Return all metric objects for the current user
     */
    async getAllMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MetricRepresentation>> {
        const response = await this.getAllMetricsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return all raw metrics (metric definitions that are defined by data provider).
     */
    async getAllRawMetricsRaw(requestParameters: GetAllRawMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RawMetricRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['assigned'] != null) {
            queryParameters['assigned'] = requestParameters['assigned'];
        }

        if (requestParameters['dataprovider'] != null) {
            queryParameters['dataprovider'] = requestParameters['dataprovider'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/raw-metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RawMetricRepresentationFromJSON));
    }

    /**
     * Return all raw metrics (metric definitions that are defined by data provider).
     */
    async getAllRawMetrics(assigned?: boolean, dataprovider?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RawMetricRepresentation>> {
        const response = await this.getAllRawMetricsRaw({ assigned: assigned, dataprovider: dataprovider }, initOverrides);
        return await response.value();
    }

    /**
     * Return merged coverage for all metrics of the given generators.
     * Return metrics coverage.
     */
    async getCoverageForAllMetricsRaw(requestParameters: GetCoverageForAllMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CoverageRepresentation>>> {
        if (requestParameters['coverageRequest'] == null) {
            throw new runtime.RequiredError(
                'coverageRequest',
                'Required parameter "coverageRequest" was null or undefined when calling getCoverageForAllMetrics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/coverages`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CoverageRequestToJSON(requestParameters['coverageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CoverageRepresentationFromJSON));
    }

    /**
     * Return merged coverage for all metrics of the given generators.
     * Return metrics coverage.
     */
    async getCoverageForAllMetrics(coverageRequest: CoverageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CoverageRepresentation>> {
        const response = await this.getCoverageForAllMetricsRaw({ coverageRequest: coverageRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing metric.
     * Update metric
     */
    async updateMetricRaw(requestParameters: UpdateMetricOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateMetric().'
            );
        }

        if (requestParameters['updateMetricRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMetricRequest',
                'Required parameter "updateMetricRequest" was null or undefined when calling updateMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/metrics/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMetricRequestToJSON(requestParameters['updateMetricRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Update an existing metric.
     * Update metric
     */
    async updateMetric(key: string, updateMetricRequest: UpdateMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricRepresentation> {
        const response = await this.updateMetricRaw({ key: key, updateMetricRequest: updateMetricRequest }, initOverrides);
        return await response.value();
    }

}
